import { render, staticRenderFns } from "./MinhasLicitacoesTabelaAcaoPrincipal.vue?vue&type=template&id=0559d546"
import script from "./MinhasLicitacoesTabelaAcaoPrincipal.vue?vue&type=script&lang=js"
export * from "./MinhasLicitacoesTabelaAcaoPrincipal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports